module.exports = __webpack_public_path__ + "static/media/ballot-check.0c7595fa.svg";